import { saveAs } from 'file-saver';

export async function downloadFile(fileSrc: string, nameOfDownload: string) {
  const link = `${fileSrc}?response-content-disposition=attachment;filename=${nameOfDownload}`;
  const blob = await fetch(link).then((r) => r.blob());
  return saveAs(blob, nameOfDownload);
}

export async function openFile(fileSrc: string, nameOfDownload: string) {
  const anchorElement = document.createElement('a');
  anchorElement.href = fileSrc;
  anchorElement.target = '_blank';
  anchorElement.download = nameOfDownload;
  anchorElement.style.display = 'none';
  document.body.appendChild(anchorElement);
  anchorElement.click();
  anchorElement.remove();
}
